export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Administracja": "Administration",
        "Akceptuj": "Accept",
        "Aktywne kanały komunikacji": "Active communication channels",
        "Anuluj": "Cancel",
        "Błąd w kodzie MJML.": "Error in MJML code.",
        "Centrum powiadomień": "Notification center",
        "Data utworzenia": "Creation date",
        "Data wysłania": "Send date",
        "Dodaj szablon": "Add template",
        "Dodaj typ": "Add type",
        "Dodaj wiadomość": "Add message",
        "Dodaj zmienną": "Add variable",
        "Dodaj zmienne dla szablonu": "Add variables for template",
        "Dodane przez": "Added by",
        "Dodawanie komunikatu": "Adding message",
        "Dodawanie szablonu powiadomień": "Adding notification template",
        "Dodawanie typu powiadomienia": "Adding notification type",
        "Edycja komunikatu": "Editing message",
        "Edycja szablonu powiadomień": "Editing notification template",
        "Edycja typu powiadomienia": "Editing notification type",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Only templates of enabled and supported channels can be edited.",
        "Edytuj": "Edit",
        "Edytuj szablon": "Edit template",
        "Edytuj typ": "Edit type",
        "Edytuj wiadomość": "Edit message",
        "ID": "ID",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Channel is required by default. It cannot be disabled for sending notifications via this channel. Only the title and content of the message can be changed.",
        "kanał wymagany": "channel required",
        "Kanały": "Channels",
        "Kanały komunikacji": "Communication channels",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
        "Kanały włączone w ustawieniach aplikacji": "Channels enabled in application settings",
        "Kategoria": "Category",
        "Klucze": "Keys",
        "Kod MJML": "MJML code",
        "Konfiguracja domyślna": "Default configuration",
        "Konfiguracja stopki oraz logo wiadomości mailowych.": "Email message footer and logo configuration.",
        "Kopiuj": "Copy",
        "Lista jest pusta": "List is empty",
        "Logo": "Logo",
        "Logo jest wspólne dla wszystkich wersji językowych.": "Logo is shared across all language versions.",
        "Moje dokumenty": "My documents",
        "Nazwa": "Name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa szablonu": "Template name",
        "Nazwa typu": "Type name",
        "Nazwa zmiennej": "Variable name",
        "Nazwa zmiennej nie może być pusta.": "Variable name cannot be empty.",
        "Nie udało się pobrać listy kanałów": "Failed to retrieve channel list",
        "Nie udało się pobrać listy powiadomień": "Failed to retrieve notification list",
        "Nie udało się pobrać powiadomień.": "Failed to retrieve notifications.",
        "Nie udało się wykonać akcji": "Failed to perform action",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Odznacz wszystkie": "Deselect all",
        "Poczta wychodząca": "Outgoing mail",
        "Podgląd HTML": "HTML preview",
        "Podgląd szablonu": "Template preview",
        "Pokaż w koncie użytkownika": "Show in user account",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Powiadomienia": "Notifications",
        "Powiadomienia mailowe": "Email notifications",
        "Powiadomienia zostały skonfigurowane.": "Notifications have been configured.",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Notification is required by default. It cannot be disabled.",
        "Powiadomienie testowe zostało wysłane.": "Test notification has been sent.",
        "Powiadomienie zbiorowe zostało dodane.": "Bulk notification has been added.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Bulk notification has been updated.",
        "Powiększ kod MJML": "Expand MJML code",
        "Powiększ podgląd": "Zoom in preview",
        "Powrót": "Back",
        "Stan powiadomienia": "Notification state",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status powiadomienia": "Notification status",
        "Stopka": "Footer",
        "Stopkę ustawiasz osobno dla każdej wersji językowej.": "Set footer separately for each language version.",
        "Strona główna": "Home page",
        "System": "System",
        "System powiadomień": "Notification system",
        "Szablon został dodany.": "Template has been added.",
        "Szablon został usunięty.": "Template has been deleted.",
        "Szablon został zaktualizowany.": "Template has been updated.",
        "Szablony email": "Email templates",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel can send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel cannot send formatted text.",
        "Testuj": "Test",
        "Treść": "Content",
        "Typ powiadomienia": "Notification type",
        "Typy powiadomień": "Notification types",
        "Tytuł": "Title",
        "Tytuł powiadomienia": "Notification title",
        "Ustawienia": "Settings",
        "Ustawienia powiadomień zostały zaktualizowane.": "Notification settings have been updated.",
        "Usuń": "Delete",
        "Wczytywanie danych…": "Loading data…",
        "Wersje": "Versions",
        "Włącznik wysyłki wszystkich powiadomień.": "Switch for sending all notifications.",
        "Włączone": "Enabled",
        "Włączony": "Enabled",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wszystko": "All",
        "wybierz": "select",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select notification type to see available keys.",
        "wybierz...": "select...",
        "Wybór języka": "Language selection",
        "Wyłączony": "Disabled",
        "Wymagane": "Required",
        "Wymagane kanały pozostają zawsze aktywne.": "Required channels always remain active.",
        "Wyślij do": "Send to",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Errors in form. Check all form fields.",
        "Wysyłaj tym kanałem": "Send via this channel",
        "Wysyłka wiadomości": "Sending messages",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No communication channel has been enabled in notification settings.",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz ustawienia": "Save settings",
        "Zaznacz wszystkie": "Select all",
        "Zmiana hasła": "Password change",
        "Zmienne": "Variables"
    }
};
